import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import './SchedulingShowcase.css';

const SchedulingShowcase: React.FC = () => {
  const containerRef = useRef<HTMLElement>(null);
  const isInView = useInView(containerRef, { 
    once: true, 
    margin: "-20% 0px -20% 0px",
    amount: 0.4
  });

  return (
    <section className="scheduling-showcase" ref={containerRef}>
      <div className="scheduling-container">
        <motion.div 
          className="scheduling-image"
          initial={{ opacity: 0, x: -100, y: 50 }}
          animate={isInView ? { opacity: 1, x: 0, y: 0 } : { opacity: 0, x: -100, y: 50 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <img 
            src="/images/HomeChased.png" 
            alt="Genix AI Scheduling Interface" 
            className="interface-image"
          />
        </motion.div>

        <motion.div 
          className="scheduling-content"
          initial={{ opacity: 0, x: 100, y: 50 }}
          animate={isInView ? { opacity: 1, x: 0, y: 0 } : { opacity: 0, x: 100, y: 50 }}
          transition={{ duration: 1, ease: "easeOut", delay: 0.2 }}
        >
          <h2>Say Goodbye to Scheduling Chaos</h2>
          <p>Create rotas effortlessly by typing or uploading an Excel file — our AI handles the rest with precision.</p>
          <motion.button 
            className="learn-more-btn"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            style={{backgroundColor:'white',color:'#0191c6',border:'1px solid #0191c6'}}
          >
            Learn More
          </motion.button>
        </motion.div>
      </div>
    </section>
  );
};

export default SchedulingShowcase; 